import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {SumarigramaContainer} from './Screen';

export const SumarigramaView = () =>{

    return (
        <Page title={'Sumarigrama'} scrollBody>{<SumarigramaContainer menu={true} style={{overflow:'auto',height: '90%', border:'none'}}/>}</Page>
    )
}